<template>
  <div v-if="visivel" class="guardadas-overlay" @keydown.esc.stop.prevent="$emit('fechar')" @click.self="$emit('fechar')">
    <section class="guardadas-modal" role="dialog" aria-modal="true" aria-labelledby="guardadas-title">
      <header class="guardadas-header">
        <h3 id="guardadas-title">Vendas guardadas</h3>
        <button type="button" class="guardadas-close" aria-label="Fechar" @click="$emit('fechar')">×</button>
      </header>
      <div class="guardadas-busca">
        <input ref="busca" v-model="filtro" type="search" placeholder="Buscar identificação ou cliente..." aria-label="Buscar venda guardada" />
        <p>Recupere o atendimento para continuar incluindo itens e concluir a venda.</p>
      </div>
      <p v-if="erro" class="guardadas-erro" role="alert">{{ erro }}</p>
      <div class="guardadas-lista">
        <p v-if="!filtradas.length" class="guardadas-vazio">{{ vendas.length ? 'Nenhuma venda corresponde à busca.' : 'Nenhuma venda guardada neste terminal.' }}</p>
        <article v-for="venda in filtradas" :key="venda.uuid" class="guardadas-venda">
          <div class="guardadas-info">
            <strong>{{ venda.identificacao || venda.nome_cliente || 'Venda sem identificação' }}</strong>
            <span v-if="venda.nome_cliente && venda.nome_cliente !== venda.identificacao">{{ venda.nome_cliente }}</span>
            <small>{{ dataHora(venda.created_at) }} · {{ venda.quantidade_itens }} {{ venda.quantidade_itens === 1 ? 'item' : 'itens' }}</small>
          </div>
          <strong class="guardadas-total">{{ formatBRL(venda.valor_total) }}</strong>
          <div class="guardadas-acoes">
            <button type="button" class="guardadas-recuperar" @click="$emit('recuperar', venda)">Recuperar</button>
            <button type="button" class="guardadas-excluir" @click="$emit('excluir', venda)">Excluir</button>
          </div>
        </article>
      </div>
      <footer class="guardadas-footer">
        <span>As vendas ficam guardadas neste terminal, inclusive após fechar o PDV.</span>
        <button type="button" @click="$emit('fechar')">Fechar</button>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: "VendasGuardadasModal",
  props: {
    visivel: { type: Boolean, default: false },
    vendas: { type: Array, default: () => [] },
    erro: { type: String, default: "" },
  },
  data: () => ({ filtro: "" }),
  computed: {
    filtradas() {
      const termo = this.filtro.trim().toLocaleLowerCase("pt-BR");
      return this.vendas.filter(v => `${v.identificacao || ""} ${v.nome_cliente || ""}`.toLocaleLowerCase("pt-BR").includes(termo));
    },
  },
  watch: {
    visivel(valor) {
      if (valor) {
        this.filtro = "";
        this.$nextTick(() => { if (this.$refs.busca) this.$refs.busca.focus(); });
      }
    },
  },
  methods: {
    formatBRL(valor) { return Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }); },
    dataHora(valor) {
      const iso = valor && !valor.includes("T") ? `${valor.replace(" ", "T")}Z` : valor;
      const data = new Date(iso);
      return Number.isNaN(data.getTime()) ? "" : data.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
    },
  },
};
</script>

<style scoped>
.guardadas-overlay { position: fixed; inset: 0; z-index: 4100; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgba(0,0,0,.5); }
.guardadas-modal { width: 820px; max-width: 100%; max-height: 88vh; display: flex; flex-direction: column; overflow: hidden; border-radius: 10px; background: #fff; color: #334155; font-size: 14px; }
.guardadas-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 18px; border-bottom: 1px solid #e2e8f0; }
.guardadas-header h3 { margin: 0; font-size: 17px; font-weight: 700; }
.guardadas-close { border: 0; background: transparent; font-size: 24px; color: #64748b; }
.guardadas-busca { padding: 12px 18px 0; }
.guardadas-busca input { width: 100%; padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 14px; }
.guardadas-busca p { margin: 8px 0; font-size: 12px; color: #64748b; }
.guardadas-lista { overflow-y: auto; min-height: 100px; padding: 0 18px 12px; }
.guardadas-vazio { padding: 24px 0; text-align: center; color: #64748b; }
.guardadas-venda { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 12px 0; border-bottom: 1px solid #e2e8f0; }
.guardadas-info { flex: 1; min-width: 160px; display: flex; flex-direction: column; gap: 3px; overflow-wrap: anywhere; }
.guardadas-info small { color: #64748b; font-size: 12px; }
.guardadas-total { font-size: 17px; white-space: nowrap; }
.guardadas-acoes { display: flex; gap: 6px; }
.guardadas-modal button { cursor: pointer; }
.guardadas-acoes button, .guardadas-footer button { padding: 7px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 14px; }
.guardadas-recuperar { background: var(--primary-color, #ee7361); border-color: var(--primary-color, #ee7361) !important; color: #fff; }
.guardadas-excluir { background: #fff5f5; color: #b91c1c; }
.guardadas-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 18px; background: #f8fafc; border-top: 1px solid #e2e8f0; font-size: 12px; }
.guardadas-footer button { background: #fff; }
.guardadas-erro { margin: 8px 18px; padding: 10px; border-radius: 6px; color: #b91c1c; background: #fef2f2; }
</style>
